// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { CSSTransitionGroup } from '../../../../node_module_clones/react-transition-group';

// Utils
import { isEmpty } from '../../../../common/utils/immutableHelper';

// Selectors
import { getPoiId } from '../poiSelector';

// Components
import pointerLayerConnect from './pointerLayerConnect';
import pointerLayerRectObserver from './pointerLayerRectObserver';
import pointerLayerMountDecorator from './pointerLayerMountDecorator';
import markSeenCanvasPointersDecorator from './markSeenCanvasPointersDecorator';
import groupPointersDecorator from './groupPointersDecorator';
import PointerSwitch from './pointerTypes/PointerSwitch';

// Styles
import './PointerLayer.scss';

@pointerLayerConnect
@pointerLayerMountDecorator
@pointerLayerRectObserver
@markSeenCanvasPointersDecorator
@groupPointersDecorator
class PointerLayer extends React.Component {
    render() {
        const { pointers, layerRect, gridSize } = this.props;

        if (isEmpty(pointers)) return null;

        return (
            <div className="PointerLayer">
                {pointers.map((pointer) => (
                    <CSSTransitionGroup
                        key={getPoiId(pointer)}
                        transitionName="slide"
                        transitionAppear
                        transitionAppearTimeout={1000}
                        transitionEnterTimeout={1000}
                        transitionLeaveTimeout={1000}
                    >
                        <PointerSwitch gridSize={gridSize} pointer={pointer} layerRect={layerRect} />
                    </CSSTransitionGroup>
                ))}
            </div>
        );
    }
}

PointerLayer.propTypes = {
    animatePointers: PropTypes.bool,
    measurements: PropTypes.object,
    layerRect: PropTypes.object,
    pointers: PropTypes.array,
    gridSize: PropTypes.number,
};

export default PointerLayer;
